import * as Yup from 'yup';

import {
  CreateLicenseField,
  getLicenseFieldWrongTypeErrorMessage,
} from '@converge/data';

export const stringRequired = (fieldName: CreateLicenseField) => {
  return Yup.string()
    .typeError(getLicenseFieldWrongTypeErrorMessage(fieldName))
    .required(getLicenseFieldWrongTypeErrorMessage(fieldName))
    .trim()
    .min(1, getLicenseFieldWrongTypeErrorMessage(fieldName));
};

export const CreateLicenseFieldsSchema = Yup.object({
  [CreateLicenseField.LicenseTypeUuid]: stringRequired(
    CreateLicenseField.LicenseTypeUuid
  ),
  [CreateLicenseField.LicenseExpirationDate]: Yup.date()
    .nullable()
    .when(
      ['perpetual', 'licenseHolderUuid'],
      ([perpetual, licenseHolderUuid], schema) => {
        // If perpetual or using another broker's license (licenseHolderUuid is set), allow null
        if (perpetual === true) {
          return schema.nullable();
        } else {
          return schema

            .required('This field is required')
            .min(new Date(), 'Expiration date must be in the future');
        }
      }
    ),
  [CreateLicenseField.LicenseRegionUuid]: stringRequired(
    CreateLicenseField.LicenseRegionUuid
  ),
  [CreateLicenseField.LicenseNumber]: stringRequired(
    CreateLicenseField.LicenseNumber
  ),
  [CreateLicenseField.LicenseHolderUuid]: stringRequired(
    CreateLicenseField.LicenseHolderUuid
  ),
});
